export default __webpack_public_path__ + "ea68bb0eab6113234281ccb2b4f77163.svg";